import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Link from '@mui/material/Link';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { PKUrl } from 'components';
import { codelists } from 'constants/codelists';
import { generateInfoCircleTooltip } from 'features/views/marketPlace/utils';
import { equalOrThreeDashes, getCodelistByName, getCodelistPropById, getRoutePath, phoneToLink } from 'utils';
import { generateFullNameOrBusinessName } from 'utils/string';

export const SubTableRowInProgressAndAfterDeadline = ({ item }) => {
	const navigate = useNavigate();
	const { client = {}, lastNote, id, clientLoadedFromCcd } = item;
	const { id: partnerId, address = {}, phone, kclPhone, email, kclEmail, businessName, firstName, surname } = client;
	const { municipality, zipCode } = address;
	const finalEmail = kclEmail || email;

	const finishTypesCodelist = useSelector(getCodelistByName(codelists.finishTypes));

	const handleRedirectToDetail = useCallback(
		(leadId) => () => {
			const { pathname, state } = getRoutePath('leadDetail', { leadId }, true);
			navigate(pathname, { state });
		},
		[navigate],
	);

	const generateFeedbackValue = (finishTypeId) => {
		if (!isNilOrEmpty(finishTypeId)) {
			const value = getCodelistPropById(item?.finishTypeId, finishTypesCodelist);
			return <Chip label={value} sx={{ fontWeight: 'bold' }} />;
		} else {
			return equalOrThreeDashes();
		}
	};

	return (
		<TableRow className="SubTableRow--Body">
			<TableCell />
			<TableCell>
				<PKUrl.PKPartner partnerId={clientLoadedFromCcd && partnerId} taskId={id} muiLink unlock>
					{generateFullNameOrBusinessName(businessName, surname, firstName)}
				</PKUrl.PKPartner>
			</TableCell>
			<TableCell>{municipality}</TableCell>
			<TableCell>{zipCode}</TableCell>
			<TableCell>{phoneToLink(kclPhone || phone, true)}</TableCell>
			<TableCell>
				<Link underline="none" href={`mailTo:${finalEmail}`}>
					{finalEmail}
				</Link>
			</TableCell>
			<TableCell>{generateFeedbackValue(item?.finishTypeId)}</TableCell>
			<TableCell>{generateInfoCircleTooltip(lastNote)}</TableCell>
			<TableCell>
				<Link underline="none" onClick={handleRedirectToDetail(id)}>
					<Box sx={{ color: 'primary.main', fontWeight: 'bold' }}>{getLabelMessage('common:detail')}</Box>
				</Link>
			</TableCell>
		</TableRow>
	);
};

SubTableRowInProgressAndAfterDeadline.propTypes = {
	finishTypesCodelist: PropTypes.array,
	item: PropTypes.object,
};

export default SubTableRowInProgressAndAfterDeadline;
